import React, { useContext } from 'react';
import Header from '../common/Header';
import LocaleContext from 'constants/localization';

export default function BooleanDisplay({field, mode}) {
  const { values } = field;
  const LS = useContext(LocaleContext);
  const value = values[0];

  return (
    <div className={`field ${mode}`} >
      <Header field={field} mode={mode} />
      {value ? <span>{LS.true}</span> : <span>{LS.false}</span>}
    </div>
  );
}